webpackJsonp([34347076847770],{

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: theme.spacing.unit * 5,
	      height: theme.spacing.unit * 5,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(20),
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	    img: {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      // Handle non-square image. The property isn't supported by IE11.
	      objectFit: 'cover'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function Avatar(props) {
	  var alt = props.alt,
	      childrenProp = props.children,
	      childrenClassNameProp = props.childrenClassName,
	      classes = props.classes,
	      classNameProp = props.className,
	      Component = props.component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "childrenClassName", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet"]);
	  var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.colorDefault, childrenProp && !src && !srcSet), classNameProp);
	  var children = null;
	
	  if (childrenProp) {
	    if (childrenClassNameProp && typeof childrenProp !== 'string' && _react.default.isValidElement(childrenProp)) {
	      var childrenClassName = (0, _classnames.default)(childrenClassNameProp, childrenProp.props.className);
	      children = _react.default.cloneElement(childrenProp, {
	        className: childrenClassName
	      });
	    } else {
	      children = childrenProp;
	    }
	  } else if (src || srcSet) {
	    children = _react.default.createElement("img", (0, _extends2.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  }
	
	  return _react.default.createElement(Component, (0, _extends2.default)({
	    className: className
	  }, other), children);
	}
	
	Avatar.propTypes =  false ? {
	  /**
	   * Used in combination with `src` or `srcSet` to
	   * provide an alt attribute for the rendered `img` element.
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * Used to render icon or text elements inside the Avatar.
	   * `src` and `alt` props will not be used and no `img` will
	   * be rendered by default.
	   *
	   * This can be an element, or just a string.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * The className of the child element.
	   * Used by Chip and ListItemIcon to style the Avatar icon.
	   */
	  childrenClassName: _propTypes.default.string,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Attributes applied to the `img` element when the component
	   * is used to display an image.
	   */
	  imgProps: _propTypes.default.object,
	
	  /**
	   * The `sizes` attribute for the `img` element.
	   */
	  sizes: _propTypes.default.string,
	
	  /**
	   * The `src` attribute for the `img` element.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * The `srcSet` attribute for the `img` element.
	   */
	  srcSet: _propTypes.default.string
	} : {};
	Avatar.defaultProps = {
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAvatar'
	})(Avatar);
	
	exports.default = _default;

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(14));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(23));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(13));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(26));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(27));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(29));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(28));
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(2));
	
	var _classnames = _interopRequireDefault(__webpack_require__(5));
	
	var _keycode = _interopRequireDefault(__webpack_require__(53));
	
	var _Cancel = _interopRequireDefault(__webpack_require__(128));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(22));
	
	var _colorManipulator = __webpack_require__(94);
	
	__webpack_require__(122);
	
	// So we don't have any override priority issue.
	var styles = function styles(theme) {
	  var height = 32;
	  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
	  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);
	  return {
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(13),
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: height,
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      borderRadius: height / 2,
	      whiteSpace: 'nowrap',
	      transition: theme.transitions.create(['background-color', 'box-shadow']),
	      // label will inherit this from root, then `clickable` class overrides this for both
	      cursor: 'default',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 'none',
	      textDecoration: 'none',
	      border: 'none',
	      // Remove `button` border
	      padding: 0 // Remove `button` padding
	
	    },
	    clickable: {
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      },
	      '&:active': {
	        boxShadow: theme.shadows[1],
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.12)
	      }
	    },
	    deletable: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      }
	    },
	    avatar: {
	      marginRight: -4,
	      width: height,
	      height: height,
	      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	      fontSize: theme.typography.pxToRem(16)
	    },
	    avatarChildren: {
	      width: 19,
	      height: 19
	    },
	    label: {
	      display: 'flex',
	      alignItems: 'center',
	      paddingLeft: 12,
	      paddingRight: 12,
	      userSelect: 'none',
	      whiteSpace: 'nowrap',
	      cursor: 'inherit'
	    },
	    deleteIcon: {
	      // Remove grey highlight
	      WebkitTapHighlightColor: 'transparent',
	      color: deleteIconColor,
	      cursor: 'pointer',
	      height: 'auto',
	      margin: '0 4px 0 -8px',
	      '&:hover': {
	        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
	      }
	    }
	  };
	};
	/**
	 * Chips represent complex entities in small blocks, such as a contact.
	 */
	
	
	exports.styles = styles;
	
	var Chip =
	/*#__PURE__*/
	function (_React$Component) {
	  (0, _inherits2.default)(Chip, _React$Component);
	
	  function Chip() {
	    var _ref;
	
	    var _temp, _this;
	
	    (0, _classCallCheck2.default)(this, Chip);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return (0, _possibleConstructorReturn2.default)(_this, (_temp = _this = (0, _possibleConstructorReturn2.default)(this, (_ref = Chip.__proto__ || Object.getPrototypeOf(Chip)).call.apply(_ref, [this].concat(args))), _this.chipRef = null, _this.handleDeleteIconClick = function (event) {
	      // Stop the event from bubbling up to the `Chip`
	      event.stopPropagation();
	      var onDelete = _this.props.onDelete;
	
	      if (onDelete) {
	        onDelete(event);
	      }
	    }, _this.handleKeyDown = function (event) {
	      // Ignore events from children of `Chip`.
	      if (event.currentTarget !== event.target) {
	        return;
	      }
	
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          onDelete = _this$props.onDelete,
	          onKeyDown = _this$props.onKeyDown;
	      var key = (0, _keycode.default)(event);
	
	      if (onClick && (key === 'space' || key === 'enter')) {
	        event.preventDefault();
	        onClick(event);
	      } else if (onDelete && key === 'backspace') {
	        event.preventDefault();
	        onDelete(event);
	      } else if (key === 'esc') {
	        event.preventDefault();
	
	        if (_this.chipRef) {
	          _this.chipRef.blur();
	        }
	      }
	
	      if (onKeyDown) {
	        onKeyDown(event);
	      }
	    }, _temp));
	  }
	
	  (0, _createClass2.default)(Chip, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          avatarProp = _props.avatar,
	          classes = _props.classes,
	          classNameProp = _props.className,
	          clickable = _props.clickable,
	          Component = _props.component,
	          deleteIconProp = _props.deleteIcon,
	          label = _props.label,
	          onClick = _props.onClick,
	          onDelete = _props.onDelete,
	          onKeyDown = _props.onKeyDown,
	          tabIndexProp = _props.tabIndex,
	          other = (0, _objectWithoutProperties2.default)(_props, ["avatar", "classes", "className", "clickable", "component", "deleteIcon", "label", "onClick", "onDelete", "onKeyDown", "tabIndex"]);
	      var className = (0, _classnames.default)(classes.root, (0, _defineProperty2.default)({}, classes.clickable, onClick || clickable), (0, _defineProperty2.default)({}, classes.deletable, onDelete), classNameProp);
	      var deleteIcon = null;
	
	      if (onDelete) {
	        deleteIcon = deleteIconProp && _react.default.isValidElement(deleteIconProp) ? _react.default.cloneElement(deleteIconProp, {
	          className: (0, _classnames.default)(deleteIconProp.props.className, classes.deleteIcon),
	          onClick: this.handleDeleteIconClick
	        }) : _react.default.createElement(_Cancel.default, {
	          className: classes.deleteIcon,
	          onClick: this.handleDeleteIconClick
	        });
	      }
	
	      var avatar = null;
	
	      if (avatarProp && _react.default.isValidElement(avatarProp)) {
	        avatar = _react.default.cloneElement(avatarProp, {
	          className: (0, _classnames.default)(classes.avatar, avatarProp.props.className),
	          childrenClassName: (0, _classnames.default)(classes.avatarChildren, avatarProp.props.childrenClassName)
	        });
	      }
	
	      var tabIndex = tabIndexProp;
	
	      if (!tabIndex) {
	        tabIndex = onClick || onDelete || clickable ? 0 : -1;
	      }
	
	      return _react.default.createElement(Component, (0, _extends2.default)({
	        role: "button",
	        className: className,
	        tabIndex: tabIndex,
	        onClick: onClick,
	        onKeyDown: this.handleKeyDown,
	        ref: function ref(node) {
	          _this2.chipRef = node;
	        }
	      }, other), avatar, _react.default.createElement("span", {
	        className: classes.label
	      }, label), deleteIcon);
	    }
	  }]);
	  return Chip;
	}(_react.default.Component);
	
	Chip.propTypes =  false ? {
	  /**
	   * Avatar element.
	   */
	  avatar: _propTypes.default.element,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css-api) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If true, the chip will appear clickable, and will raise when pressed,
	   * even if the onClick property is not defined. This can be used, for example,
	   * along with the component property to indicate an anchor Chip is clickable.
	   */
	  clickable: _propTypes.default.bool,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func]),
	
	  /**
	   * Override the default delete icon element. Shown only if `onDelete` is set.
	   */
	  deleteIcon: _propTypes.default.element,
	
	  /**
	   * The content of the label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Callback function fired when the delete icon is clicked.
	   * If set, the delete icon will be shown.
	   */
	  onDelete: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
	} : {};
	Chip.defaultProps = {
	  clickable: false,
	  component: 'div'
	};
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiChip'
	})(Chip);
	
	exports.default = _default;

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	
	var _Chip = _interopRequireDefault(__webpack_require__(123));

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(6);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _pure = _interopRequireDefault(__webpack_require__(44));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(93));
	
	var _ref = _react.default.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
	});
	
	/**
	 * @ignore - internal component.
	 */
	var Cancel = function Cancel(props) {
	  return _react.default.createElement(_SvgIcon.default, props, _ref);
	};
	
	Cancel = (0, _pure.default)(Cancel);
	Cancel.muiName = 'SvgIcon';
	var _default = Cancel;
	exports.default = _default;

/***/ }),

/***/ 237:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _styles2 = __webpack_require__(238);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EndPiece = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var classes = props.classes,
	      published = props.published,
	      author = props.author;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.contents },
	    _react2.default.createElement(
	      'div',
	      { className: classes.endpiece },
	      _react2.default.createElement(
	        _Grid2.default,
	        { container: true, spacing: 40 },
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 12 },
	          author.name && _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'caption', className: classes.author },
	            '\xA9 ',
	            author.name.text
	          ),
	          _react2.default.createElement(
	            _Typography2.default,
	            { variant: 'caption', gutterBottom: true, className: classes.date },
	            published
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(EndPiece);
	module.exports = exports['default'];

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  return {
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    centred: _extends({}, (0, _mixins.Centred)(theme)),
	    endpiece: {
	      fontSize: theme.typography.subheading.fontSize,
	      background: 'rgba(255,255,255,1)',
	      padding: '2rem 7rem 0 7rem',
	      maxWidth: 1024
	      // borderBottomLeftRadius: 25,
	      // borderBottomRightRadius: 25
	    },
	    author: {
	      fontWeight: theme.typography.fontWeightMedium,
	      color: theme.typography.body1.color
	    },
	    date: {
	      marginBottom: theme.spacing.unit * 3
	    }
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 241:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Chip = __webpack_require__(124);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _share = __webpack_require__(251);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _styles2 = __webpack_require__(242);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Lead = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var classes = props.classes,
	      title = props.title,
	      published = props.published,
	      author = props.author,
	      suptitle = props.suptitle,
	      lead = props.lead,
	      tags = props.tags,
	      _props$hideSocial = props.hideSocial,
	      hideSocial = _props$hideSocial === undefined ? false : _props$hideSocial;
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.contents },
	    _react2.default.createElement(
	      'div',
	      { className: classes.lead },
	      _react2.default.createElement(
	        _Grid2.default,
	        { container: true, spacing: 40 },
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 12 },
	          tags && tags.map(function (tag, index) {
	            return _react2.default.createElement(_Chip2.default, { key: index, label: tag, className: classes.tag });
	          })
	        )
	      ),
	      _react2.default.createElement(
	        _Grid2.default,
	        { container: true, spacing: 40 },
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 12 },
	          !hideSocial && _react2.default.createElement(
	            'div',
	            { className: classes.share },
	            _react2.default.createElement(_share2.default, {
	              shareUrl: typeof document !== 'undefined' && document.location.href,
	              title: title
	            })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { display: 'inline', maxWidth: '100%' } },
	            suptitle && _react2.default.createElement(
	              _Typography2.default,
	              { className: classes.suptitle, gutterBottom: true },
	              suptitle.text
	            ),
	            _react2.default.createElement(
	              _Typography2.default,
	              { className: classes.head, gutterBottom: true },
	              title.text
	            ),
	            author && author.name && _react2.default.createElement(
	              _Typography2.default,
	              { variant: 'caption', className: classes.author },
	              author.name.text
	            ),
	            _react2.default.createElement(
	              _Typography2.default,
	              { variant: 'caption', gutterBottom: true },
	              published
	            )
	          ),
	          lead && lead.text && _react2.default.createElement(
	            _Typography2.default,
	            { className: classes.text },
	            lead.text
	          )
	        )
	      )
	    )
	  );
	});
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Lead);
	module.exports = exports['default'];

/***/ }),

/***/ 242:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  var _lead, _head;
	
	  return {
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    centred: _extends({}, (0, _mixins.Centred)(theme)),
	    lead: (_lead = {
	      fontSize: theme.typography.subheading.fontSize,
	      background: 'rgba(255,255,255,1)',
	      padding: '7rem 7rem 0 7rem',
	      maxWidth: 1024
	    }, _lead[theme.breakpoints.down('sm')] = {
	      padding: '2rem 2rem 0 2rem'
	    }, _lead),
	    suptitle: {
	      textTransform: 'uppercase',
	      fontSize: theme.typography.caption.fontSize
	      // fontWeight: 800,
	    },
	    head: (_head = {
	      display: 'flex',
	      fontSize: theme.typography.display1.fontSize,
	      fontWeight: 800,
	      lineHeight: .9,
	      textTransform: 'uppercase'
	    }, _head[theme.breakpoints.down('sm')] = {
	      fontSize: theme.typography.headline.fontSize,
	      wordBreak: 'break-word'
	    }, _head),
	    share: {
	      float: 'right'
	    },
	
	    author: {
	      fontWeight: theme.typography.fontWeightMedium,
	      color: theme.typography.body1.color
	    },
	    text: {
	      marginTop: theme.spacing.unit * 2
	    },
	    tag: {
	      marginRight: theme.spacing.unit,
	      marginBottom: theme.spacing.unit
	    }
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 244:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPlayer = __webpack_require__(89);
	
	var _reactPlayer2 = _interopRequireDefault(_reactPlayer);
	
	var _gatsbyImage = __webpack_require__(39);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _styles = __webpack_require__(11);
	
	var _styles2 = __webpack_require__(245);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Poster = function (_React$Component) {
	  _inherits(Poster, _React$Component);
	
	  function Poster() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Poster);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      isIOS: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Poster.prototype.componentDidMount = function componentDidMount() {
	    this.setState({
	      isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent)
	    });
	  };
	
	  Poster.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props = this.props,
	        classes = _props.classes,
	        image = _props.image,
	        urls = _props.urls,
	        poster = _props.poster;
	    var isIOS = this.state.isIOS;
	
	
	    return !isIOS && urls ? _react2.default.createElement(_reactPlayer2.default, {
	      ref: function ref(p) {
	        return _this2.player = p;
	      },
	      url: urls[0].src,
	      width: '100%',
	      height: '100%',
	      loop: true,
	      autoPlay: true,
	      playing: true,
	      muted: true
	    }) : image.src !== {} ? _react2.default.createElement('img', { src: image.src, className: classes.poster, alt: image.alt }) : _react2.default.createElement('div', { className: classes.poster });
	  };
	
	  return Poster;
	}(_react2.default.Component);
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Poster);
	module.exports = exports['default'];

/***/ }),

/***/ 245:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var styles = function styles(theme) {
	  var _poster;
	
	  return {
	    poster: (_poster = {
	      height: '100%',
	      width: '100%',
	      minHeight: '100vh',
	      backgroundImage: 'linear-gradient(to right top, #212a2a, #094153, #2d4f84, #864e98, #d6407d)',
	      textAlign: 'left',
	      display: 'flex',
	      alignItems: 'center'
	    }, _poster[theme.breakpoints.down('sm')] = {
	      height: '30%',
	      minHeight: '30vh'
	    }, _poster)
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 249:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _gatsbyImage = __webpack_require__(39);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gradient = __webpack_require__(83);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _styles2 = __webpack_require__(250);
	
	var _styles3 = _interopRequireDefault(_styles2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var renderImage = function renderImage(props) {
	  var classes = props.classes,
	      section = props.section;
	
	
	  return section && section.image && section.image.src && section.image.src.length > 0 && _react2.default.createElement('img', {
	    src: section.image.src,
	    alt: section.image.alt,
	    className: classes.sectionImage
	  });
	};
	
	var Section = (0, _styles.withStyles)(_styles3.default)(function (props) {
	  var classes = props.classes,
	      section = props.section;
	
	
	  return _react2.default.createElement(
	    'div',
	    { className: classes.contents },
	    _react2.default.createElement(
	      'div',
	      { className: classes.section },
	      _react2.default.createElement(
	        _Grid2.default,
	        { container: true, spacing: 40 },
	        _react2.default.createElement(
	          _Grid2.default,
	          { item: true, xs: 12 },
	          renderImage(props),
	          section && section.contents && section.contents.map(function (content, index) {
	            return _react2.default.createElement(SectionContent, { key: index, content: content, classes: classes });
	          })
	        )
	      )
	    )
	  );
	});
	
	var SectionContent = function SectionContent(_ref) {
	  var content = _ref.content,
	      classes = _ref.classes;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    content.title && _react2.default.createElement(
	      _Typography2.default,
	      { gutterBottom: true, variant: 'title' },
	      content.title.text
	    ),
	    content.subtitle && _react2.default.createElement(
	      _Typography2.default,
	      { gutterBottom: true, variant: 'subheading' },
	      content.subtitle.text
	    ),
	    content.text && _react2.default.createElement('div', {
	      dangerouslySetInnerHTML: { __html: content.text && content.text.html },
	      className: classes.text
	    })
	  );
	};
	
	exports.default = (0, _styles.withStyles)(_styles3.default)(Section);
	module.exports = exports['default'];

/***/ }),

/***/ 250:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _mixins = __webpack_require__(31);
	
	var styles = function styles(theme) {
	  var _section;
	
	  return {
	
	    contents: _extends({}, (0, _mixins.Contents)(theme)),
	    section: (_section = {
	      background: 'rgba(255,255,255,1)',
	      padding: '3rem 7rem',
	      maxWidth: 1024
	    }, _section[theme.breakpoints.down('sm')] = {
	      padding: '2rem 2rem'
	    }, _section),
	    sectionImage: {
	      width: '100%',
	      maxWidth: 1024,
	      marginBottom: theme.spacing.unit * 4
	    },
	    text: _extends({}, (0, _mixins.RichText)(theme))
	
	  };
	};
	
	exports.default = styles;
	module.exports = exports['default'];

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(5);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gatsbyImage = __webpack_require__(39);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Grid = __webpack_require__(25);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Typography = __webpack_require__(20);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _styles = __webpack_require__(11);
	
	var _fragments = __webpack_require__(46);
	
	var _mapper = __webpack_require__(38);
	
	var _metadata = __webpack_require__(42);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _poster = __webpack_require__(244);
	
	var _poster2 = _interopRequireDefault(_poster);
	
	var _lead = __webpack_require__(241);
	
	var _lead2 = _interopRequireDefault(_lead);
	
	var _quote = __webpack_require__(68);
	
	var _quote2 = _interopRequireDefault(_quote);
	
	var _section = __webpack_require__(249);
	
	var _section2 = _interopRequireDefault(_section);
	
	var _endpiece = __webpack_require__(237);
	
	var _endpiece2 = _interopRequireDefault(_endpiece);
	
	var _footer = __webpack_require__(41);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _constants = __webpack_require__(51);
	
	var _site = __webpack_require__(43);
	
	var _site2 = _interopRequireDefault(_site);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Study = function Study(props) {
	  var classes = props.classes;
	
	  var metadata = (0, _mapper.mapMetaData)(props.data.study);
	  var study = (0, _mapper.mapStudy)(props.data.study);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_metadata2.default, { data: metadata }),
	    _react2.default.createElement(_poster2.default, {
	      image: study.image,
	      urls: study.video_bg.urls,
	      poster: study.video_bg.poster
	    }),
	    _react2.default.createElement(
	      'div',
	      { className: classes.mainFloat },
	      _react2.default.createElement(_lead2.default, {
	        title: study.title,
	        author: study.author,
	        published: study.published,
	        lead: study.lead,
	        path: props.location.pathname,
	        tags: study.tags
	      }),
	      study.contents && study.contents.map(function (content, index) {
	        switch (content.type) {
	          case _constants.CONTENTTYPES.section:
	            return _react2.default.createElement(_section2.default, { key: index, section: content });
	          case _constants.CONTENTTYPES.quote:
	            return _react2.default.createElement(_quote2.default, { key: index, quote: content });
	        }
	      }),
	      _react2.default.createElement(_endpiece2.default, { author: study.author, published: study.published }),
	      _react2.default.createElement('div', { className: classes.studyEnd })
	    ),
	    _react2.default.createElement(_footer2.default, { policies: props.data.policies.edges })
	  );
	};
	
	exports.default = (0, _styles.withStyles)(_site2.default)(Study);
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-studies-study-js-1c7da2d9fb7ef0e2df09.js